import { useContext, useEffect, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import { useWindowSize } from "@/hooks/useIsMobile";
import StripeStatus from "../Symbals";

const StateKeyCandidate = ({
  stateHindi = "",
  electionPassedCategory = "",
  masterKey = "",
}) => {
  const size = useWindowSize();
  const [keyCandidatesData, setKeyCandidatesData] = useState([]);
  const masterConfig = useContext(MasterConfigContext);
  const electionKeys = masterConfig[masterKey];
  const showKeyCand = electionKeys?.showKeyCand;
  const KeyCandApi = electionKeys?.keyCandApi;
  const keyCandiShowArrow = electionKeys?.keyCandiShowArrow;
  // console.log("KeyCandApi", KeyCandApi);
  const showCandidateProfile = electionKeys?.showCandidateProfile;
  const getKeyCandidatesData = async () => {
    try {
      const response = await fetch(KeyCandApi, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data1 = await response.json();
      // console.log("data1", data1);
      let tempData = data1?.data["ALL KEY CANDIDATES"];
      let keyCandidates = tempData || [];
      setKeyCandidatesData(keyCandidates);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getKeyCandidatesData();

    if (electionKeys?.resultYear == 2026 || electionKeys?.resultYear == 2025 || electionKeys?.resultYear == 2024) {
      const interval = setInterval(() => {
        getKeyCandidatesData();
      }, 30000);

      console.log("Polling started");

      return () => clearInterval(interval);
    }
  }, []);

  // console.log(keyCandidatesData, "keyCandidatesData");
  return (
    <>
      {showKeyCand ? (
        <div className="py-2">
          <div className="flex flex-col sm:flex-row items-center justify-between h-full p-2">
            <h1 className="font-bold font-devnagri text-xl sm:text-2xl text-center sm:text-left">
              {stateHindi} विधानसभा चुनाव {electionKeys?.resultYear} के प्रमुख उम्मीदवार
            </h1>

            <div className="mt-2 sm:mt-0">
              <StripeStatus />
            </div>
          </div>

          {/* <div className="flex gap-4 my-2 border-b-2 border-customPoll">
    <div className="flex">
      <button
        className={`${
          !isRegionalTab
            ? "bg-primary text-white"
            : "bg-blue-100 text-gray-500"
        } font-semibold px-4 py-2 rounded-tr-lg rounded-tl-lg`}
        onClick={() => setIsRegionalTab(false)}
      >
        राष्ट्रीय
      </button>
    </div>
  </div> */}
          {size.width < 900 ? (
            <div
              style={{
                border: "2px solid #E2E2E2",
                borderTop: "6px solid #E2E2E2",
                marginTop: "15px",
              }}
            >
              {keyCandidatesData && keyCandidatesData.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {keyCandidatesData.map((item, index) => (
                    <div key={index} style={{ width: "100%", padding: "10px" }}>
                      <div
                        style={{
                          backgroundColor: "#F7F9FA",
                          padding: "5px 10px",
                          display: "flex",
                        }}
                      >
                        <div
                          style={{
                            width: "20%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {showCandidateProfile ? (
                            <a
                              className="hover:underline hover:text-[#CF4C9B]"
                              href={`${
                                process?.env?.NEXT_PUBLIC_WEBSITE_URL
                              }/elections/${electionPassedCategory}/candidates/${item?.CANDIDATE?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-result-${(
                                item?.CONSTITUENCY || item?.CONSTITUENCY_H
                              )
                                ?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join(
                                  "-"
                                )}-${`${item?.CID}-${item?.CANDIDATE_ID}`}`}
                            >
                              {" "}
                              <img
                                src={item?.IMAGE}
                                alt={item?.CANDIDATE_H}
                                style={{
                                  borderRadius: "50%",
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                }}
                              />
                            </a>
                          ) : (
                            <img
                              src={item?.IMAGE}
                              alt={item?.CANDIDATE_H}
                              style={{
                                borderRadius: "50%",
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            width: item?.STATUS == "" ? "65%" : "50%",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          {showCandidateProfile ? (
                            <a
                              className="hover:underline hover:text-[#CF4C9B]"
                              href={`${
                                process?.env?.NEXT_PUBLIC_WEBSITE_URL
                              }/elections/${electionPassedCategory}/candidates/${item?.CANDIDATE?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join(
                                  "-"
                                )}-result-${item?.CONSTITUENCY?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join(
                                  "-"
                                )}-${`${item?.CID}-${item?.CANDIDATE_ID}`}`}
                            >
                              {" "}
                              <p>{item?.CANDIDATE_H}</p>
                            </a>
                          ) : (
                            <p>{item?.CANDIDATE_H}</p>
                          )}
                          <a
                            className="underline hover:text-[#CF4C9B]"
                            href={`${
                              process?.env?.NEXT_PUBLIC_WEBSITE_URL
                            }/elections/${electionPassedCategory}/${item?.CONSTITUENCY?.toLowerCase()
                              .replace(/[^a-zA-Z ]/g, "")
                              .split(" ")
                              .join("-")}-assembly-constituency-result-${
                              item?.CID
                            }`}
                          >
                            {" "}
                            <p
                              style={{ fontSize: "14px" }}
                            >{`(${item?.CONSTITUENCY_H})`}</p>
                          </a>
                        </div>
                        <div
                          style={{
                            width: "14%",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={item?.PARTY_LOGO}
                            alt={item?.PARTY_H}
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                          <p
                            style={{ fontSize: "14px" }}
                          >{`(${item?.PARTY_H})`}</p>
                        </div>
                        {item?.STATUS != "" ? (
                          <div
                            style={{
                              width: "15%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {keyCandiShowArrow && (
                              <img
                                src={
                                  item?.STATUS == "WON"
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-33_0.png"
                                    : item?.STATUS == "LOST"
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-36.png"
                                    : item?.STATUS == "TRAILING"
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-34.png"
                                    : "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-35.png"
                                }
                                alt={item?.CANDIDATE_H}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "18%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          ></div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* <iframe
    title="loksabha exit poll"
    src={`https://electionresults.intoday.in/elections/2024/loksabha-elections/key-candidate/keycandidates-loksabha-result-2024.html?site=at&device=web&theme=1&v=8.8`}
    className="min-h-[550px] w-full scrollbar-none"
    height={550}
  /> */}
            </div>
          ) : (
            <div
              style={{
                border: "2px solid #E2E2E2",
                borderTop: "6px solid #E2E2E2",
                marginTop: "15px",
              }}
            >
              {keyCandidatesData && keyCandidatesData.length > 0 && (
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {keyCandidatesData.map((item, index) => (
                    <div key={index} style={{ width: "50%", padding: "10px" }}>
                      <div
                        style={{
                          backgroundColor: "#F7F9FA",
                          padding: "5px 10px",
                          display: "flex",
                        }}
                      >
                        <div
                          style={{
                            width: "20%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {showCandidateProfile ? (
                            <a
                              className="hover:underline hover:text-[#CF4C9B]"
                              href={`${
                                process?.env?.NEXT_PUBLIC_WEBSITE_URL
                              }/elections/${electionPassedCategory}/candidates/${item?.CANDIDATE?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join("-")}-result-${(
                                item?.CONSTITUENCY || item?.CONSTITUENCY_H
                              )
                                ?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join(
                                  "-"
                                )}-${`${item?.CID}-${item?.CANDIDATE_ID}`}`}
                            >
                              {" "}
                              <img
                                src={item?.IMAGE}
                                alt={item?.CANDIDATE_H}
                                style={{
                                  borderRadius: "50%",
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                }}
                              />
                            </a>
                          ) : (
                            <img
                              src={item?.IMAGE}
                              alt={item?.CANDIDATE_H}
                              style={{
                                borderRadius: "50%",
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            width: item?.STATUS == "" ? "65%" : "50%",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          {showCandidateProfile ? (
                            <a
                              className="hover:underline hover:text-[#CF4C9B]"
                              href={`${
                                process?.env?.NEXT_PUBLIC_WEBSITE_URL
                              }/elections/${electionPassedCategory}/candidates/${item?.CANDIDATE?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join(
                                  "-"
                                )}-result-${item?.CONSTITUENCY?.toLowerCase()
                                .replace(/[^a-zA-Z ]/g, "")
                                .split(" ")
                                .join(
                                  "-"
                                )}-${`${item?.CID}-${item?.CANDIDATE_ID}`}`}
                            >
                              {" "}
                              <p>{item?.CANDIDATE_H}</p>
                            </a>
                          ) : (
                            <p>{item?.CANDIDATE_H}</p>
                          )}
                          <a
                            className="underline hover:text-[#CF4C9B]"
                            href={`${
                              process?.env?.NEXT_PUBLIC_WEBSITE_URL
                            }/elections/${electionPassedCategory}/${item?.CONSTITUENCY?.toLowerCase()
                              .replace(/[^a-zA-Z ]/g, "")
                              .split(" ")
                              .join("-")}-assembly-constituency-result-${
                              item?.CID
                            }`}
                          >
                            {" "}
                            <p
                              style={{ fontSize: "14px" }}
                            >{`(${item?.CONSTITUENCY_H})`}</p>
                          </a>
                        </div>
                        <div
                          style={{
                            width: "14%",
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={item?.PARTY_LOGO}
                            alt={item?.PARTY_H}
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                          <p
                            style={{ fontSize: "14px" }}
                          >{`(${item?.PARTY_H})`}</p>
                        </div>

                        {item?.STATUS != "" ? (
                          <div
                            style={{
                              width: "15%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {keyCandiShowArrow && (
                              <img
                                src={
                                  item?.STATUS == "WON"
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-33_0.png"
                                    : item?.STATUS == "LOST"
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-36.png"
                                    : item?.STATUS == "TRAILING"
                                    ? "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-34.png"
                                    : "https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/image-35.png"
                                }
                                alt={item?.CANDIDATE_H}
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  // objectFit: "none",
                                }}
                              />
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "18%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          ></div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {/* <iframe
    title="loksabha exit poll"
    src={`https://electionresults.intoday.in/elections/2024/loksabha-elections/key-candidate/keycandidates-loksabha-result-2024.html?site=at&device=web&theme=1&v=8.8`}
    className="min-h-[550px] w-full scrollbar-none"
    height={550}
  /> */}
            </div>
          )}
          {/* <p className="my-2">
          चुनाव आयोग (Election Commission) ने 16 मार्च को लोकसभा चुनाव 2024
          (Lok Sabha Election 2024) की तारीखों का ऐलान कर दिया. इस चुनाव के
          लिए 7 फेज में मतदान होगा और वोटों की गिनती 4 जून को होगी. सातों
          फेज की वोटिंग क्रमशः 19 अप्रैल, 26 अप्रैल, 7 मई, 13 मई, 20 मई, 25
          मई और एक जून को होगी. वोटों की गिनती के बाद 4 जून को ही नतीजों का
          ऐलान कर दिया जाएगा.
        </p>
        <AdSlot728x90
          divId="div-gpt-ad-1702014298509-2"
          minWidth="720px"
          minHeight="90px"
        /> */}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default StateKeyCandidate;
